/// <amd-module name="Agile/Taskboard/CustomColumn/State/CustomColumnActions" />
import { ActionsUnion, createAction } from "VSS/ActionHelpers/ActionHelpers";

export const enum CustomColumnActionTypes {
    Validate = "CustomColumnActions/Validate",
    AddColumn = "CustomColumnActions/AddColumn",
    ReorderColumn = "CustomColumnActions/ReorderColumn",
    RemoveColumn = "CustomColumnActions/RemoveColumn",
    RenameColumn = "CustomColumnActions/RenameColumn",
    UpdateState = "CustomColumnActions/UpdateState",
    SelectColumn = "CustomColumnActions/SelectColumn",
    Saving = "CustomColumnActions/Saving",
    SaveFailed = "CustomColumnActions/SaveFailed"
}

export const CustomColumnActions = {
    validate: () => createAction(CustomColumnActionTypes.Validate),
    selectColumn: (columnIndex: number) => createAction(CustomColumnActionTypes.SelectColumn, { columnIndex }),
    addColumn: () => createAction(CustomColumnActionTypes.AddColumn),
    reorderColumn: (columnId: string, newIndex: number) => createAction(CustomColumnActionTypes.ReorderColumn, { columnId, newIndex }),
    removeColumn: (columnId: string) => createAction(CustomColumnActionTypes.RemoveColumn, { columnId }),
    renameColumn: (columnId: string, newColumnName: string) => createAction(CustomColumnActionTypes.RenameColumn, { columnId, newColumnName }),
    updateState: (columnId: string, workItemType: string, state: string) =>
        createAction(CustomColumnActionTypes.UpdateState, { columnId, workItemType, state }),
    saving: () => createAction(CustomColumnActionTypes.Saving),
    saveFailed: (error: Error) => createAction(CustomColumnActionTypes.SaveFailed, { error })
};

export type CustomColumnActions = ActionsUnion<typeof CustomColumnActions>;
